import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Stack,
    IconButton,
    useMediaQuery,
    useTheme
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';

const ResponsiveDialog = props => {
    const [open, setOpen] = useState(props.isOpen || false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const minWidth = props.minWidth || '500px';
    const minHeight = props.minHeight || '30dvh';
    const titleFontSize = props.titleFontSize || { xs: '1.5rem', sm: '2rem' };

    useEffect(() => {
        setOpen(props.isOpen);
    }, [props.isOpen]);

    const handleClose = (event, reason) => {
        if (props.preventBackdropClick && reason && reason === "backdropClick") {
            if (props.onClose) {
                return props.onClose(event, reason);
            }
            return;
        }
        if (props.onClose) return props.onClose(event, reason);
        setOpen(false);
    };

    return (
        <>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{ display: { sx: "flex", sm: 'initial' } }}
                PaperProps={{
                    sx: props.paperSx
                }}
            >
                {props.title ? (
                    <DialogTitle
                        sx={{
                            fontSize: titleFontSize,
                            borderBottom: '1px solid #ddd',
                            position: 'relative',
                            pr: props.showMobileCloseButton ? { xs: 6, sm: 2 } : 2,
                            ...props.titleSx
                        }}
                        id="responsive-dialog-title"
                    >
                        {props.title}
                        {(props.showCloseButton || (props.showMobileCloseButton && fullScreen)) ? (
                            <IconButton
                                aria-label="chiudi finestra"
                                onClick={handleClose}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: '50%',
                                    transform: 'translateY(-50%)'
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        ) : null}
                    </DialogTitle>
                ) : null}
                <Stack flexGrow={1} boxSizing={"border-box"} p={0} minHeight={minHeight} minWidth={{ xs: '100dvw', sm: minWidth }} width={'100%'} justifyContent='center' alignItems='center'>
                    <DialogContent sx={{ display: 'flex', ...props.contentSx }} p={1} px={{ xs: 1, sm: 4 }}>
                        {props.children}
                    </DialogContent>
                </Stack>
                {props.actions ? (
                    <DialogActions sx={{ borderTop: '1px solid #ddd', ...props.actionsSx }}>
                        {props.actions}
                    </DialogActions>
                ) : null}
            </Dialog>
        </>
    );
}

export default ResponsiveDialog;
